import React, {useState} from "react";

export const CheckboxInput = ({property}) => {
    const [, forceUpdate] = useState();
    return (
        <input
            type="checkbox"
            checked={property.get()}
            onChange={e => {
                forceUpdate(property.set(e.target.checked));
                APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
            }}
        />
    );
}

